import { Control, Controller, useWatch } from 'react-hook-form';

import { TextField } from '@/components/shared/TextField/TextField';
import { ExploreBlockType } from '@addmile/backend-client';
import Editor from '@monaco-editor/react';

import { BlockFormData } from '../schema';

type ContentFieldProps = {
  control: Control<BlockFormData>;
};

export const ContentField = ({ control }: ContentFieldProps) => {
  const type = useWatch({ control, name: 'type' });
  const isVideo = type === ExploreBlockType.Video;
  const needsContent = type !== ExploreBlockType.Video;

  return (
    <div className="space-y-4">
      {needsContent && (
        <div>
          <label className="block text-sm font-medium text-neutral-70 mb-2">Content (JSON)</label>
          <Controller
            name="content"
            control={control}
            render={({ field }) => (
              <div className="border border-neutral-20 rounded-md overflow-hidden">
                <Editor
                  height="50vh"
                  defaultLanguage="json"
                  language="json"
                  value={field.value || '[]'}
                  onChange={(value) => field.onChange(value || '[]')}
                  theme="vs-light"
                  options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    lineNumbers: 'on',
                    scrollBeyondLastLine: false,
                    automaticLayout: true,
                    formatOnPaste: true,
                    formatOnType: true,
                    tabSize: 2,
                    wordWrap: 'on',
                    wrappingIndent: 'indent',
                    suggestOnTriggerCharacters: true,
                    acceptSuggestionOnEnter: 'on',
                    quickSuggestions: true,
                    bracketPairColorization: { enabled: true },
                  }}
                />
              </div>
            )}
          />
        </div>
      )}

      {isVideo && (
        <div>
          <label className="block text-sm font-medium text-neutral-70 mb-2">Video URL</label>
          <Controller
            name={'videoUrl'}
            control={control}
            render={({ field }) => (
              <TextField {...field} placeholder="https://...mp4" className="!w-full" />
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ContentField;
